import { useConexaQuery } from '@/hooks/useConexaQuery'
import { ChatService } from '../services/chat.services'
import { cacheTime } from '@/constants/cacheTime/cacheTime'

export const useGetChatToken = ({ enabled = false }) => {
  return useConexaQuery({
    queryKey: ['chatToken'],
    service: ChatService.getChatToken,
    config: {
      enabled,
    },
  })
}

export const usePatientHasNearbyAppointments = ({ enabled = false }) => {
  return useConexaQuery({
    queryKey: ['patientHasNearbyAppointments'],
    service: ChatService.patientHasNearbyAppointments,
    config: {
      enabled,
      staleTime: cacheTime.FIVE_MINUTES,
    },
  })
}
